import Image from "@/components/common/Image";
import { useI18n } from "@/common/I18nProvider";

export default function HeroHomeOne() {
  const { messages } = useI18n();
  const hero = messages.hero;
  const about = messages.about;

  return (
    <section className="hero-section">
      <div className="container">
        <div className="row justify-content-between g-4">
          {/* <!-- Hero Content --> */}
          <div className="col-12 col-md-6 col-lg-6">
            <div className="hero-content">
              <h2 className="text-white mb-0 heading-chars" data-delay="0.3">{hero.fullTitle || hero.title}
              </h2>
            </div>
          </div>

          {/* <!-- Hero Content --> */}
          <div className="col-12 col-md-6 col-lg-5">
            <div className="hero-content">
              {/* <!-- Image Group Wrap --> */}
              <div className="hero-image fadeInUp mt-0" data-delay="0.7">
          <Image
            src="/assets/img/bg-img/different-car-accessories-arrangement (1).jpg"
            alt={`${about.companyName} - ${hero.title}`}
            width={1920}
            height={1080}
            className="w-auto h-auto"
            priority
          />
        </div>
              <p className="mt-5 mb-0 text-white heading-line" data-delay="0.6">{hero.detailedDescription || hero.description}</p>
            </div>
          </div>
        </div>

        {/* <!-- Divider --> */}
        <div className="divider"></div>

        {/* <!-- Hero Image --> */}
       
      </div>
    </section>
  )
}
